export const OPT_OUT_NEWSLETTER = 'Opt_out_newsletter';
